import { Dots } from "@/components/carousel/Carousel.types";
import { HoverSwapGallery } from "@/features/pdp/media-gallery/HoverSwapGallery";
import React from "react";
import { PdpCarousel } from "./PdpCarousel";
import { ThumbnailGallery } from "./ThumbnailGallery";

interface MediaGalleryProps {
  mode: "carousel" | "thumbnail" | "hoverSwap";
  dots?: Dots | "none";
}

export const MediaGallery = ({ mode, dots }: MediaGalleryProps) => {
  if (mode === "hoverSwap") {
    return <HoverSwapGallery />;
  }

  return mode === "carousel" ? (
    <PdpCarousel dots={dots} />
  ) : (
    <ThumbnailGallery />
  );
};
